// useExport.js
import * as XLSX from "xlsx";

/**
 * Exports an array of objects to CSV.
 * @param {Array} data - Array of objects representing rows.
 * @param {string} filename - The desired filename (default "data.csv").
 */
export const exportToCSV = (data, filename = "data.csv") => {
  if (!data || data.length === 0) return;

  // Create CSV header from keys of the first object.
  const header = Object.keys(data[0]).join(",") + "\n";

  // Convert each row to CSV format.
  const rows = data
    .map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    )
    .join("\n");

  const csvContent = header + rows;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Exports an array of objects to XLSX format.
 * @param {Array} data - Array of objects representing rows.
 * @param {string} filename - The desired filename (default "data.xlsx").
 */
export const exportToXLSX = (data, filename = "data.xlsx") => {
  if (!data || data.length === 0) return;

  // Convert JSON data to worksheet.
  const worksheet = XLSX.utils.json_to_sheet(data);
  // Create a new workbook and append the worksheet.
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // Write the workbook to a file.
  XLSX.writeFile(workbook, filename);
};

/**
 * A custom hook that returns export functions.
 * @returns {object} - Contains exportToCSV and exportToXLSX functions.
 */
const useExport = () => {
  return { exportToCSV, exportToXLSX };
};

export default useExport;
